<template>
  <div class="phone-charge-records">
    <div v-if="!firstLoaded" style="height: 30vh;"></div>
    <van-empty
      class="custom-image"
      :image="emptyImgUrl"
      description="暂无数据"
      v-else-if="chargeRecordList.length == 0"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="chargeRecordList.length === 0 ? '' : '没有更多内容了'"
      @load="getRecordList"
      class="custom-list"
    >
      <div v-for="(item, index) in chargeRecordList" :key="index">
        <div class="records__item" @click="openDetail(item.orderNo)">
          <div class="left">
            <div class="title">{{ item.phoneAttribution }}</div>
            <div class="phone">{{ item.rechargePhone | phoneFilter }}</div>
          </div>
          <div class="right">
            <div class="cost">¥{{ item.productSkuName }}</div>
            <div
              class="status"
              :class="{
                red: item.rechargeStatus === STATUS.cancel,
                blue: [STATUS.unpaid, STATUS.processing].includes(item.rechargeStatus),
              }"
            >
              {{ item.rechargeStatusName }}
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import pic_default from "@/assets/img/car-life/pic_default.png";
import { carLifeOrderList } from "@/common/api.js";

const STATUS = {
  unpaid: "00", // 待支付
  processing: "01", // 充值中
  success: "02", // 充值成功
  cancel: "03", //已取消
};

export default {
  name: "phone-charge-records",

  filters: {
    phoneFilter(value) {
      if (value) {
        return value.replace(/^(\d{3}).*(\d{3})$/, "$1*****$2");
      }
      return "";
    },
  },

  data() {
    return {
      STATUS,
      emptyImgUrl: pic_default,
      chargeRecordList: [],
      pageSize: 10,
      pageNum: 1,
      loading: true,
      finished: false,
      // 标记是否首次加载
      firstLoaded: false,
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.pageNum = 1;
      this.getRecordList();
    },
    async getRecordList() {
      try {
        const res = await carLifeOrderList({
          pageNum: this.pageNum++,
          pageSize: this.pageSize,
          productCategoryCodes: ['FL00000002']
        });
        this.loading = false;
        this.firstLoaded = true;
        let list = res.list;
        if (!list) {
          list = [];
        }
        this.chargeRecordList = [...this.chargeRecordList, ...list];
        if (list.length < this.pageSize) {
          this.finished = true;
        }
      } catch {
        this.loading = false;
        this.firstLoaded = true;
      }
    },

    openDetail(id) {
      this.$router.push({
        name: "phoneChargeDetail",
        query: {
          orderNo: id,
        },
      });
    },
  },
};
</script>

<style>
.van-empty {
  padding: 0;
  margin-top: 1.83rem;
}

.custom-image .van-empty__image {
  width: 3.88rem;
  height: 2.44rem;
}
</style>

<style lang="scss" scoped>
.phone-charge-records {
  font-size: 0.32rem;
  padding-top: 0.25rem;
  background: #f4f6f7;
  min-height: 100vh;
  overflow-y: scroll;

  .custom-list {
    height: 100vh;
    overflow-y: scroll;
  }

  .records {
    &__item {
      box-sizing: border-box;
      width: 100vw;
      height: 1.92rem;
      padding: 0 0.4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      box-shadow: inset 0px -2px 0px 0px rgba(230, 230, 230, 1);

      @mixin columnFlex {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 1rem;
      }

      .left {
        flex: 1;
        @include columnFlex();

        .title {
          font-size: 0.32rem;
          // font-family: PingFangSC-medium;
          color: #383838;
        }
        .phone {
          color: #787878;
        }
      }

      .right {
        text-align: right;
        margin-left: 0.24rem;
        @include columnFlex();

        .cost {
          font-family: PingFangSC-Medium;
          font-size: 0.4rem;
        }
        .status {
          color: #787878;
          font-size: 0.24rem;
          &.red {
            color: #ff4242;
          }
          &.blue {
            color: #3399ff;
          }
        }
      }
    }
  }
}
</style>
